export default __webpack_public_path__ + "static/media/portfolio-hover-167.ff57dddf.jpg";